/**
 * 公共商品详情页面脚本
 * 2023年06月14日
 */
var ProductImages = [];
var variant_init=0;

$(function () {
  /**
   * 处理格式化产品详情数据 
   */
  function productDes() {
    // 除了第一个隐藏 后面所有
    $("#pr_des_warp .tab_title_block").first().addClass('active');
    $("#pr_des_warp .des_item").hide();
    $("#pr_des_warp .des_item:lt(1)").show();
    // 监听事件
    $(".container_des").on("click", '.tab_title_block', function () {
      const mid = $(this).attr("id");
      // 移出所有的class
      $("#pr_des_warp .tab_title_block").removeClass('active');
      $(this).addClass('active');
      $("#pr_des_warp .des_item").each(function () {
        let selId = $(this).attr('id');
        if (selId == mid) {
          $(this).show();
        } else {
          $(this).hide();
        }
      })
    });

    // 优惠券是否倒计时功能
    const countdown = $('#pprDiscountTime').attr('attr-countdown');
    if (countdown) {
      const ends = $('#pprDiscountTime').attr('ends');
      const days = $('#pprDiscountTime').attr('days');
      const hours = $('#pprDiscountTime').attr('hours');
      const minutes = $('#pprDiscountTime').attr('minutes');
      const secs = $('#pprDiscountTime').attr('secs');
      startCountdown(countdown, 'pprDiscountTime', ends, days,hours,minutes,secs);
    }

  // // 初始化二级变体
    // if (!isMobile()) {
    //   $('.size_medium .swatch:gt(0)').each(function(){
    //      $(this).find('.swatch__list_pr:not(.j-swatch-list) .swatch_pr_item:gt(2)').hide();
    //      console.log($(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length)
    //      let swatchNum = $(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length - 3;
    //      if(swatchNum > 0) {
    //       $(this).find('.j-swatch-even-more').text('+' + swatchNum).show();;
    //      }
    //   })
    // }
    // 移动端
  }

  function mDataProcessing() {
   

    // 描述点击事件
    $('#pr_des_warp').on('click', '.tab_title_block', function (e) {
      if ($(this).find('.op-fold').hasClass('opened')) {
        $(this).find('.op-fold').removeClass('opened');
        $(this).find('.m-deatil').stop().slideUp(200);
      } else {
        $(this).find('.op-fold').addClass('opened');
        $(this).find('.m-deatil').stop().slideDown(200);
      }
    });
    $('#pr_des_warp .tab_title_block')[0].click()

  }

  /**
 * 初始化方法
 */
  function init() {
    // 处理详情数据
    productDes();
    // 所有事件监听
    productListenEvent();
    // 移动端判断
    if (isMobile()) {
      mDataProcessing();
    } else {
      var intervalLaw = setInterval(function () {
        if ($('#shopify-section-cookies_law.pp_onshow').length > 0 || $('#shopify-section-cookies_law.pp_onhide').length > 0) {
          let flag = $('#shopify-section-cookies_law.pp_onshow').length > 0;
          if (flag) {
            $('#p_floatCart').css({ 'bottom': '65px' });
          } else {
            $('#p_floatCart').css({ 'bottom': '0px' });
          }
          clearInterval(intervalLaw)
        }
      }, 1000)
      $('body').on('click', '.pp_cookies_accept_btn', function (e) {
        $('#p_floatCart').css({ 'bottom': '0px' });
      });
    }
    const payName = $('.zl-product-payment').attr('title');
    // 延迟更新
    // 更改直接购买名称
    payment(payName);
  }
  init();
})

/**
 * 循环执行修改名称
 */
function payment(payName) {
  // 默认循环10次
  var num = 0;
  var interval = setInterval(function () {
    // 最多执行10次
    if (num > 9){
      clearInterval(interval);
    }
    $('#p_floatCart').show();
    if ($(`.zl-product-payment .shopify-payment-button__more-options`).text() == payName) {
      $(`.zl-product-payment`).css({ 'opacity': 1 })
      clearInterval(interval);
    } else {
      $(`.zl-product-payment .shopify-payment-button__more-options`).text(payName);
    }
    num++;
  }, 1000)
}

/**
 * 产品所有事件监听方法
 * 2023-06-16
 */
function productListenEvent() {
  // j-swatch-more"
  // more 更多点击事件
  $('.p_ProductInner').on('click', '.j-swatch-more', function (e) {
   $(this).toggleClass("is-show");
    $(this).parents('.swatch').find('.swatch_list_show').stop().slideToggle(200);

    //  j-swatch_show
  });
  // .slideUp(200);

  //  选择颜色事件
  $('.p_ProductInner').on('click', '.j-swatch-list .swatch_pr_item', function (e) {
    const index = $(this).attr("data-index"),parid=$(this).parent(".j-swatch-list").data("id"),value=$(this).data("value");
    // 当前选项的展示list
    const swatchItem = $(`.nt_select_ppr${parid} .swatches-select .swatch_pr_item:not(.j-swatch-more)`);
     
   
   
   // 当前索引
   $(this).addClass("is-selected").siblings().removeClass("is-selected");
   
   $(`.nt_select_ppr${parid} .swatches-select .swatches-show-select-item[data-value='${value}']`).click();
 
    // 处理二级分类
  
  });

  // moer 变体二以上的点击事件
  // $('.p_ProductInner').on('click', '.j-swatch-even-more', function (e) {
  //   let value = $(this).parents('.swatch').find('.swatches-select .is-selected').attr('data-escape');
  //   $(this).parents('.swatch').find('.j-swatch_even_show .j-swatch-even—active').text(value);
  //   $(this).parents('.swatch').find('.j-swatch_even_show').show();
 
  //   //  j-swatch_show
  // });

  // 选择颜色事件
  $('.p_ProductInner').on('click', '.j-swatch-even-list .swatch_pr_item', function (e) {
    const index = $(this).attr("data-index");
    const ths =  $(this).parents('.swatch').find('.swatches-select');
    const swatchItem = $(ths).find('.swatch_pr_item:not(.j-swatch-even-more)');
    $(this).parents('.swatch').find('.j-swatch-more').removeClass("is-show");

//  // 计算需要显示的元素范围
//  let startIndex = Math.max(index - 2, 0);
//  let endIndex = Math.min(index, swatchItem.length - 1);
 
//  if (index === '0') {
//   endIndex = Math.min(index + 2, swatchItem.length - 1);
// }

// if(index!=1){
// swatchItem.slice(startIndex, endIndex + 1).show();
// }
// else{
// swatchItem.slice(0,3).show();
// }

    


    // 当前索引
    $(swatchItem).eq(index).show().click();
    // 隐藏弹出框
    $(this).parents('.swatch').find('.j-swatch_even_show').hide();
  });
  // 优惠码 复制
  $(".p_ProductInner .j-discount-copy").on('click', function (event) {
    const text = $(this).attr('text');
    const successText = $(this).attr('success');
    const defText = $(this).attr('defText');

    copyTxt(text)
    $(this).parents('.item').addClass("copied");
    // event.preventDefault();
    $(this).html(successText);
    let that = this;
    // Copier le code
    setTimeout(function () {
      $(that).parents('.item').removeClass("copied");
      $(that).html(defText);
    }, 1500)
  });

  // why-choose 点击事件
 if (!isMobile()) {
    $(".p_ProductInner .why-choose").on('click', function (event) {
      $(this).addClass('active');
    })
  }

  $('#sp_qty_ppr .qty').on('change', function () {
    $('.sticky_atc_wrap .qty').val($(this).val());
  });

  // 隐藏
  $('body').on('click', function (e) {
    var target = $(e.target);
  // if (target[0].className == 'las la-angle-down') {
    //   $('.j-swatch_show').slideUp(200);
    //   $('.j-swatch_even_show').slideUp(200);
    // }
    // if (target.closest('.swatch_more').length > 0 || target.closest('.box-head').length > 0 || target.closest('.swatch__list_pr').length > 0) return;

    // if (target.closest('.swatch_even_more').length > 0 || target.closest('.j-swatch-even-list').length > 0) return;
    // $('.j-swatch_show').slideUp(200);
    // $('.j-swatch_even_show').slideUp(200);

    if (target.closest('.j-why-item').length > 0) return;
    $('.why-choose').removeClass('active');
  });

  // 三点描述 调整到底部
  $('.p_ProductInner').on('click', '.j-simple-desc', function (e) {
    var hTop = $('.container_des').offset().top;
    $('body,html').animate({
      scrollTop: hTop - 100
    }, 700);
    // 选中第一个
    $('.container_des .tab_title_block')[0].click();
  })
}
//排序

 
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
  };
  
  
  function variantTagSort(){
    return false;
    if(variant_init==0){

 
   let 
   totalNum=$(".variations .swatch.is-color .swatches-show-select-item:not(.j-swatch-more)").length,
   saleNum=$(".variations .swatch.is-color .swatches-show-select-item[data-saletag='true']:not(.j-swatch-more)").length,
      newNum=$(".variations .swatch.is-color .swatches-show-select-item[data-newtag='true']:not(.j-swatch-more)").length,
        targetElNum=totalNum-saleNum;
    $(".variations .swatch.is-color .swatches-show-select-item[data-currentsaletag='false']").each(function(){
   
    $(".variations .swatch.is-color .swatches-show-select-item:not(.j-swatch-more)").eq(saleNum-1).after($(this));
   });
   $(".variations .swatch.is-color .swatches-hide-select-item[data-currentsaletag='false']").each(function(){

    $(".variations .swatch.is-color .swatches-hide-select-item:not(.j-swatch-more)").eq(saleNum-1).after($(this));
   });
   variant_init++;    
  }
  }
  function checkVariantWidth(type) {
    return false;
   $(".swatches-show-select-item").removeClass("swatches-show-select-item-init-hide");
    
  $("#callBackVariant_ppr .variations .swatch").each(function(){
    let $this=$(this); 
    if(!$(this).hasClass("is-color")){
      $this.find('.swatches-show-select .swatch_pr_item:not(.nt_unavailable)').show();
      $this.find('.swatches-hide-select .swatch_pr_item:not(.nt_unavailable)').show();
          }
          $this.find('.swatches-show-select .swatch_pr_item.j-swatch-more').hide();
          $this.find(`.swatches-show-select .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-more)`).removeClass("position-hide");

 
    let containerWidth = $this.find('.swatches-select').width(),
        itemWidth = 30,
        item_num=0,
        maxItems=0,
        totalLength=$this.find('.swatches-show-select .swatch_pr_item:not(.j-swatch-more):not(.nt_unavailable)').length;
        $this.find('.swatches-show-select .swatch_pr_item:not(.j-swatch-more):not(.nt_unavailable)').each(function(){
        let $that=$(this);
        if($that.outerWidth(true)>20){


          
          itemWidth += $that.outerWidth(true);
       
      if(containerWidth>itemWidth){ 
        item_num++;
        maxItems=item_num;
       }
        
      }
    })
  
console.log( maxItems,$this.find(`.swatches-show-select .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-more):gt(${maxItems-1})`));

 
    // 如果.swatch_pr_item的数量超过一行最多容纳的数量，就隐藏多余的
     
      $this.find(`.swatches-show-select .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-more):gt(${maxItems-1})`).hide().addClass("position-hide");
      // 修改多少个已经被隐藏
        let hideNum=totalLength-maxItems;
        if(hideNum == 0){
          $this.find('.swatches-show-select .swatch_pr_item.j-swatch-more').hide();
        }else{
          $this.find('.swatches-show-select .swatch_pr_item.j-swatch-more').show();
        }
        if(type=="reset"){
          $this.find(".j-swatch_even_show").hide();
        }
        $this.find('.swatches-show-select .swatch_pr_item.j-swatch-more .swatch_more').text(`+${hideNum}`);
        $this.find('.swatches-hide-select .swatch_pr_item:not(.nt_unavailable)').show();
        $this.find('.swatches-hide-select .swatch_pr_item:not(.nt_unavailable):lt(' + (maxItems) + ')').hide();
  })
  
  
  }
 
    

/**
 * 格式化产品文字
 * variantId 变体对象id
 * */
function formatProduct(id,pid,type) {
  _productHtml = '';
  console.log('formatProduct -----',type);
  // 处理描述内容
  if(type!="qv"){
// 处理描述内容
  var variantMetafields = gProductJson.variants.filter(x => x.id == id)
  variantMetafields = variantMetafields[0];

  console.log(variantMetafields);
  if(variantMetafields==undefined)return;
  var _htmlFeatures = variantMetafields.features;
 
  var _tempFeatures = '<ul class="left">';
  for (let i = 0; i < _htmlFeatures.length; i++) {
    if (_htmlFeatures[i] !== '') {
      _tempFeatures += `<li>${_htmlFeatures[i].replace(/\s/g, ' ')}</li>`;
    }
  }
  _tempFeatures += '</ul>'
  $('#pr_des_warp .key_features').html(_tempFeatures)

  // 更新title
  var brand = $('.product_title').attr("data-name");
   $('.product_title,.breadcrumb-box .title-bold').html(brand + ' ' + variantMetafields.title);
  // 更新 Specifications
  let prDescHtml = '';
  if (variantMetafields.specifications.length > 0 || variantMetafields.packages.length > 0) { // specifications
    let _speciHtml = '<ul><div class="left"><li><b>Specifications:</b></li>';
    let _specifications = variantMetafields.specifications
    for (let i = 0; i < _specifications.length; i++) {
      _speciHtml += `<li>${_specifications[i]
        }</li>`;
    }
    let packagesHtml = '';
    for (let i = 0; i < variantMetafields.packages.length; i++) {
      packagesHtml += `<li>${variantMetafields.packages[i]
        }</li>`;
    }
    _speciHtml += `</div><div class="right"><span style="font-weight: 700;">Package&nbsp;Contents:</span>
          <br><div>${packagesHtml}</div></div>`;
    _speciHtml += '</ul>'
    $('#pr_des_warp .description').html(_speciHtml);
    prDescHtml = _speciHtml
  } else {
    prDescHtml = variantMetafields.descriptions
  }
  $('#pr_des_warp .description').html(prDescHtml);

  // faq QA
  var faq = '';
  var _faqHtml = '<div class="ziel-qa-list"><ul>';
  var faqList = variantMetafields.faqs;
  if (faqList.length < 1) {
    faqList = defaultFaq;
  }
  for (let i = 0; i < faqList.length; i++) {
    let ths = faqList[i];
    _faqHtml += `<li><label>Q: ${ths.question
      }</label><span>A: ${ths.answer
      }</span></li>`
  }
  _faqHtml += '</ul></div>'
  $('#pr_des_warp .questions_answers').html(_faqHtml);
  // 图片
  ProductImages = variantMetafields.images;

// // 处理二个变体的情况
  // // 处理 变体的情况
  // $('.size_medium .swatch:gt(0)').each(function () {
  //   let swatchNum = $(this).find('.swatches-select .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').length;
  //   if (swatchNum > 3 && !isMobile()) {
  //     $(this).find('.j-swatch-even-more').show();
  //     $(this).find('.j-swatch-even-more').text(`+${swatchNum - 3}`);
  //   } else {
  //     $(this).find('.j-swatch-even-more').hide();
  //     setTimeout(function () {
  //       $(this).find('.swatch__list_pr .swatch_pr_item:not(.nt_unavailable):not(.j-swatch-even-more)').show();
  //     }, 500)
  //   }
  // })
}

 

    
  // $('.j-swatch_even_show').slideUp(200);
  // var _html = $('.nt_select_ppr1 .swatches-select').html();
  // var _this = $('.j-swatch-even-list').html(_html);
  // $(_this).find('.j-swatch-even-more').remove();
  // $(_this).find('.nt_unavailable').remove();
  // $(_this).find('.swatch_pr_item').show();

  // 初始化图片
  if(type!="qv"){
  initProductImages();
  }
  // 判断是否有亚马逊链接
  /**
   * 无库存时将到货通知的按钮样式替代为 buy on amzon，并点击跳转到对应 attribution link；
     当商品在shopify的inventory stock>0 或 tag有 “new” or “New” ，隐藏buy on amazon按钮，恢复正常按钮
     attribution link数据由中台提供，stock>0/new tag由shopify提供
   */
     if(type!="qv"){
  if ((variantMetafields.inventory_quantity) == 0 && !(gProductJson.tags.includes("new") || gProductJson.tags.includes("New"))) {
    if (variantMetafields.amazon_url){
      $(`.p_floatCart-${pid} .box-outStock .btn-amazon`).removeClass('klaviyo-bis-trigger').attr('href', variantMetafields.amazon_url).attr("target", "_blank").text('Buy on amazon')
    } else {
      let text = $('.box-outStock .btn-amazon').attr('klaviyo');
      $(`.p_floatCart-${pid} .box-outStock .btn-amazon`).addClass('klaviyo-bis-trigger').attr('href', '').attr("target", "").text(text);
    }
  }
  
  // 判断是否有库存
  if ((variantMetafields.inventory_quantity) > 0 || Boolean(variantMetafields.available)) {
    stockDisplay(true,pid);

  } else {
    stockDisplay(false,pid);
  }
  // 判断是否是预购
  if((variantMetafields.inventory_quantity) == 0 && Boolean(variantMetafields.available)) {
    // 预购
   
    $(`.p_floatCart-${pid} .m-btns`).addClass('pre-order');
    // 添加样式
  } else {
    $(`.p_floatCart-${pid} .m-btns`).removeClass('pre-order');
  }
}

}


/**
 * 倒计时
 */
function startCountdown(date, id, ends, _days,_hours,_minutes,_secs) {
  const targetDate = new Date(date);
  const countdownElement = document.getElementById(id);
  function updateCountdown() {
    const currentDate = new Date();
    const remainingTime = targetDate - currentDate;
    if (remainingTime <= 0) { 
      return;
    }
    let _countdownHtml = ends;
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
    //判断是否倒计时结束
    // days.toString().padStart(2, "0")

    _countdownHtml += `${days} ${_days} `;
    
   
    _countdownHtml += `${hours.toString().padStart(2, '0')} ${_hours} `;
  
    _countdownHtml += `${minutes.toString().padStart(2, '0')} ${_minutes} `;
 
    _countdownHtml += `${seconds.toString().padStart(2, '0')} ${_secs} `;

 
    countdownElement.innerHTML = _countdownHtml;
    setTimeout(updateCountdown, 1000);
  }
  updateCountdown();
}

/**
 * 库存显示
 * true 显示
 */
function stockDisplay(flag,pid) {
  console.log('init - cart ', flag,pid);
  if (flag) {
    //  新版本 有库存
    $(`.p_floatCart-${pid} .sticky_total_price`).show();
    $(`.p_floatCart-${pid} .sticky_atc_js`).show()
    $(`.p_floatCart-${pid} .discount-recommended`).show();
    $(`.buy-and-add-button-box`).show();
    $(`.p_floatCart-${pid} .box-outStock`).removeClass('active');
    $(`.p_floatCart-${pid} .box-outStock a`).hide();
    $(`.p_floatCart-${pid} .m-btns`).show();
    $(`.p_floatCart-${pid} .box-outStock .btn-stock`).text("");
    $('.p-main-image .nt_labels .out-of-stock').text("").hide();
    //  没有库存隐藏移动端折扣信息
    if (isMobile() && $('.m-discount-block').attr("attr-save") > 0 ) {
      $(`.p_floatCart-${pid} .m-price`).show();
      $(`.p_floatCart-${pid} .m-discount-block`).show();
    }
  } else {
    // 底部没有库存判断
 $(`.p_floatCart-${pid} .box-outStock .btn-stock`).text("Epuisé");
    $('.p-main-image .nt_labels .out-of-stock').text("Epuisé").show();
    $(`.p_floatCart-${pid} .sticky_atc_price`).hide();
    $(`.p_floatCart-${pid} .m-price`).hide();
    $(`.p_floatCart-${pid} .sticky_atc_js`).hide()
    $(`.p_floatCart-${pid} .discount-recommended`).hide();
     
    $(`.p_floatCart-${pid} .box-outStock`).addClass('active');
    $(`.p_floatCart-${pid} .box-outStock a`).show();
    $(`.p_floatCart-${pid} .m-btns`).hide();
    $(`form[data-productid="${pid}"] .buy-and-add-button-box`).hide();
    //  没有库存隐藏移动端折扣信息
    if (isMobile()) {
      $(`.p_floatCart-${pid} .m-discount-block`).hide();
    }
  }
}



// 添加prime按钮代码  // 请求bwp按钮元素
 
$(function(){
  let hasCbbStatus = false, initBuildCbbTime = '', hasCbbTime = 500;
  $(document).ready(function () {
      initBuildCbbTime = window.setInterval(() => {
          hasCbbTime += 500;
          if (hasCbbTime == 4000) {
              window.clearInterval(initBuildCbbTime);
          }
          if ($("body").has("#bwpFrame").length != 0) {
            bwpSet();
              window.clearInterval(initBuildCbbTime);
          }
  
         
      }, 500);
  })
  
   function bwpSet(){
    $("#clone-amzn-buy-now").before($("#bwpFrame").clone(true));
    let src=$("#bwpFrame").attr("src");
    $.ajax({
        url: src,
        type: 'GET',
        dataType: 'text',
        crossDomain: true,
        success: function(content) {
           
            var tempElement = $('<div>').html(content);
        
            if(tempElement.find("#container").hasClass("hidden")){
  $(".p_floatCart .operating-area .bwpbutton").addClass("bwp-btn-hide");
  $(".hide-bwp-btn-box").hide();
            }
             
        }
    });
    
    
   }
    
  })
  
  $(function(){
    let hasCbbStatus = false, initBuildCbbTime = '', hasCbbTime = 500;
    $(document).ready(function () {
        initBuildCbbTime = window.setInterval(() => {
            hasCbbTime += 500;
            if (hasCbbTime == 4000) {
                window.clearInterval(initBuildCbbTime);
            }
            if ($("body").has(".vtl-ub-bundle-box__atc-section").length != 0) {
              console.log("这里 ");
             $(".vtl-ub-bundle-box__product-list").after($(".vtl-ub-bundle-box__atc-section"));
              $("#product-bundle-container-box").append($("#bundle-product-bundles")); 
                window.clearInterval(initBuildCbbTime);
            }  
        }, 500);
    })
    
   
    })
  
  
    // 初始化左侧橱窗图top位置
    $(function(){
  let header_height=$(".main-header").outerHeight(true);
  $(".product-images").css("top",`${header_height}px`);
    })
  
  // 显示与隐藏浮动加购栏
    $(window).scroll(function() {
      if($(".variations_button").length > 0){
   
      let variations_button_position=$(".variations_button").offset().top, windowScrollTop = $(window).scrollTop()+$(".main-header").outerHeight(true);
      if(variations_button_position+$(".buy-and-add-button-box").outerHeight(true)<=windowScrollTop){
   $("#p_floatCart").addClass("show-p_floatCart");
    }else{
      $("#p_floatCart").removeClass("show-p_floatCart");
    }
             
      }
    });
    
  
    // tabbar操作
  $(function(){
  $(document).ready(function(){
    if($(".product-a-plus-container .pc-box div").length<=0&&$(".product-a-plus-container .mb-box div").length<=0){
  $(`.item[data-target="detail-tabbar-item"]`).hide();
  $(".product-a-plus-container-box").hide();
    } 
    let header_height=$(".main-header").outerHeight(true);
    $(".product-tabbar-box .item").click(function(){
      let target=$(this).data("target");
     $(this).addClass("active").siblings().removeClass("active");
      if(target.includes("review")&&!target.includes("preview")){
        $("html, body").animate({
          scrollTop:$(`ryviu-widget`).offset().top -$(window).height()*1/4
     }, 99);
      }else if(target.includes("detail")){
        $("html, body").animate({
          scrollTop:$(`.product-a-plus-container-box`).offset().top -$(window).height()*1/4
     }, 99);
  
      }
      else{
      
        $("html, body").animate({
          scrollTop:$(`.${target}`).offset().top -$(window).height()*1/4
     }, 99);
  
      }
      return false;
    })
  })
  })
  
  
    // 移动端隐藏bwp按钮
    $(function(){
      if($(window).width()>768)return;
      $(".p_floatCart .operating-area .bwpbutton").addClass("mb-bwp-hide");
    $(".hide-bwp-btn-box").click(function(){
      $(".p_floatCart .operating-area .bwpbutton").removeClass("mb-bwp-hide");
      $(this).toggleClass("show-box");
      $(".p_floatCart .operating-area .bwpbutton").slideToggle();
    })
      })
      
  
    // 移动端隐标题换位置
    $(function(){
      if($(window).width()<=589){
       $(".p_ProductInner .product_title").after($(".p_ProductInner .reivew-sku-block"));
      }
      })
      
    // 显示与隐藏移动端tabbar栏
    $(function(){
      $(window).scroll(function() {
        if($(".why-choose").length > 0){
       let target_position=$(".why-choose").offset().top, windowScrollTop = $(window).scrollTop()+$(".main-header").outerHeight(true);
       if(target_position<=windowScrollTop){
     $(".product-tabbar-box-mb").addClass("show-tabbar");
     $(".sp_header_mid").hide();
     }else{
       $(".product-tabbar-box-mb").removeClass("show-tabbar");
       $(".sp_header_mid").show();
     }
    }
     });
     
     $(".product-tabbar-box-mb-inner .icon-box").click(function(){
       $("html, body").animate({
         scrollTop:0
     }, 500);
     return false;
     })
     })
     
  // 处理评论和问答 
  $(function(){
    let hasCbbStatus = false, initBuildCbbTime = '', hasCbbTime = 500, initBuildCbbTime2="" ;
    $(document).ready(function () {
        initBuildCbbTime = window.setInterval(() => {
  
            if ($("body").has(".r--stars_average").length != 0||$("body .r--empty-review").length!=0) {
             setReviewLayout();
             setReviewNum();
                window.clearInterval(initBuildCbbTime);
            }
        }, 500);
    })
    function setReviewLayout(){
      return false;
      let main_el=$("ryviu-widget"),
      msg_el=$("#js-reivew-msg"),
      tabbar_el=`<div class="review-tabbar-box">
      <div class="item item-review-content active">
      ${msg_el.data("reviewitemreviewtitle")}
      </div>
      <div class="item item-question-content">
      ${msg_el.data("reviewitemquestiontitle")} 
      </div>
      </div>`;
      $("questions-answers").hide();
     
       initBuildCbbTime2 = window.setInterval(() => {
        hasCbbTime+=500;
        console.log($(".r--title-btn-appryviu").length!=0,"weqweqweqw");
          if($("body .r--header-empty").length!=0||$("body .r--empty-review").length!=0||$(".r--title-btn-appryviu").length!=0){
            $(".r--title-btn-appryviu").after(tabbar_el);
          }
         if(main_el.find(".r--stars_average").length!=0){
            
            main_el.find(".r--overview").after(tabbar_el);
          }
        
          
          
          if($(".r--title-btn-appryviu").length!=0||$("body .r--header-empty").length!=0||$("body .r--empty-review").length!=0||$(".r--overview").length!=0){
            
            window.clearInterval(initBuildCbbTime2);
          }
           
  
  
          if(hasCbbTime == 80000){
            window.clearInterval(initBuildCbbTime2);
          }
       
    }, 500); 
  
    
      
    }
    function setReviewNum(){
      let that=$(".product-tabbar-box .item[data-target='review-tabbar-item']");
           let title=that.text();
             let main_el=$("ryviu-widget");
            let r_avg=main_el.find(".r--stars_average").text()||"";
            console.log(title,r_avg,'r_avg');
            that.append(`${r_avg}`);
       }
       $(".r--widget-wapper .r-container").addClass("container");
       $(".r--widget-wapper .r-container").addClass("custom-r-container");
       $(".r--widget-wapper .custom-r-container").removeClass("r-container");
    $("body").on("click",".item-review-content",function(){
      $(this).addClass("active").siblings().removeClass("active");
      let main_el=$("ryviu-widget");
      main_el.find(".r--filter-ryviu").show();
      main_el.find(".r--body").show();
      main_el.find(".r--header-empty").show();
      $("questions-answers").hide();
      main_el.find(".Ryviu-Empty-Box").show();
      
    })
    $("body").on("click",".item-question-content",function(){
      $(this).addClass("active").siblings().removeClass("active");
      let main_el=$("ryviu-widget");
      main_el.find(".r--filter-ryviu").hide();
      main_el.find(".Ryviu-Empty-Box").hide();
      
      main_el.find(".r--body").hide();
      main_el.find(".r--header-empty").hide();
      $("questions-answers").show();
    })
    })
   

  
  
       
  // 处理tag
  $(function(){
      $("#product-tag-container-box .item-img").each(function(){
        let img_el=$(this).find("img"),
        src=img_el.attr("src");
        let imageUrl = formatImage(src, 300);
        console.log(imageUrl,"imageUrl");
        $(this).find("img").attr("src",imageUrl);
      })
      $("#product-tag-container-box").removeClass("hide-tag");
  })
  
  
 